/** Decorative marks next to hero “Packaging” — brand shapes from design (46×70) */
export function PackagingHeadlineDecor({ className }: { className?: string }) {
  return (
    <svg
      width="46"
      height="70"
      viewBox="0 0 46 70"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden
    >
      <g className="packaging-headline-star-spin">
        <path
          d="M46 56.5393L40.5567 58.1224L46 59.7048L40.3314 59.6888L45.1088 62.7429L39.6748 61.1291L43.399 65.4061L38.6389 62.3253L41.0086 67.4789L37.3084 63.1812L38.131 68.7938L35.7906 63.6269L35 69.2448L34.2094 63.6269L31.869 68.7938L32.6916 63.1812L28.9921 67.4789L31.3611 62.3253L26.601 65.4061L30.3252 61.1291L24.8912 62.7429L29.6686 59.6888L24 59.7048L29.4433 58.1224L24 56.5393L29.6686 56.5553L24.8912 53.5018L30.3252 55.1156L26.601 50.8387L31.3611 53.9195L28.9921 48.7659L32.6916 53.0635L31.869 47.4503L34.2094 52.6179L35 47L35.7906 52.6179L38.131 47.4503L37.3084 53.0635L41.0086 48.7659L38.6389 53.9195L43.399 50.8387L39.6748 55.1156L45.1088 53.5018L40.3314 56.5553L46 56.5393Z"
          fill="#DA5B9B"
        />
      </g>
      <circle cx="13.5" cy="25.5" r="13.5" fill="#53A4CF" />
      <circle cx="30" cy="6" r="6" fill="#F4D86E" />
    </svg>
  );
}
